import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

/**
 * @Author: 韩祺涛
 * @Date: 2022-11-28
 * @Project: 杭氧
 */
// 获取资产分类树
export function getAssisTree (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict/query',
    method: 'GET',
    params: parameter
  })
}
// 获取资产分类
export function getAssisClass (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/getZCFL',
    method: 'GET',
    params: parameter
  })
}
// 获取资产分类选中的
export function getAssisClassByType (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/assetType/getAssetTypeByType',
    method: 'GET',
    params: parameter
  })
}
// 获取资产分类选中的
export function saveAssisClassByType (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/assetType',
    method: 'PUT',
    data: parameter
  })
}